import { useMutation, useQuery } from '@tanstack/react-query';
import type { GrammarCheckResult } from '@peles/shared';
import { checkGrammar, fetchBedrockModels } from '../api/ai';

/** Bedrock foundation models for the App Settings model picker. */
export function useBedrockModels(enabled = true) {
  return useQuery({
    queryKey: ['bedrock-models'],
    queryFn: fetchBedrockModels,
    enabled,
    staleTime: 15 * 60 * 1000,
  });
}

/** Grammar/spelling suggestion for a draft message. */
export function useGrammarCheck() {
  return useMutation<GrammarCheckResult, Error, string>({
    mutationFn: (text: string) => checkGrammar(text),
  });
}
